var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguageLearning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 148,
    viewBox: "0 0 259 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98 116C73.6995 116 54 96.3005 54 72C54 47.6995 73.6995 28 98 28C122.301 28 142 47.6995 142 72C142 96.3005 122.301 116 98 116Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119 148C94.6995 148 75 128.301 75 104C75 79.6995 94.6995 60 119 60C143.301 60 163 79.6995 163 104C163 128.301 143.301 148 119 148Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M163 100C136.49 100 115 78.5097 115 52C115 25.4903 136.49 4 163 4C189.51 4 211 25.4903 211 52C211 78.5097 189.51 100 163 100Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M162 142C135.49 142 114 120.51 114 94C114 67.4903 135.49 46 162 46C188.51 46 210 67.4903 210 94C210 120.51 188.51 142 162 142Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122 88C97.6995 88 78 68.3005 78 44C78 19.6995 97.6995 0 122 0C146.301 0 166 19.6995 166 44C166 68.3005 146.301 88 122 88Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(-1 0 0 1 259 51)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-1 0 0 1 62 142)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 3 56)",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 61 4)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 213 0)",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 238 141)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11322_9753)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.3496,
    y: 24.792,
    width: 104,
    height: 104,
    transform: "rotate(-3 83.3496 24.792)",
    fill: "#E94524"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.691 49.0342L137.11 57.0232",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.077 55.7666L113.143 58.2787",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.088 56.1852V56.1852C149.44 73.1395 138.002 87.377 122.233 94.5951L119.126 96.0173",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.132 57.8607V57.8607C126.533 74.3407 139.396 87.3047 155.833 92.8349L159.072 93.9245",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27 15.5L46.5 22.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M229.5 24L248.5 16",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M229 111.5L247.5 116",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 112.5L17.5 119",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11322_9753"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.3496,
    y: 24.792,
    width: 104,
    height: 104,
    rx: 40,
    transform: "rotate(-3 83.3496 24.792)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageLearning);
export default __webpack_public_path__ + "static/media/language-learning.e4b685981897008c00cf34886dacf15c.svg";
export { ForwardRef as ReactComponent };